import Raven from 'raven-js';
export const logError = (exceptionError, errorTags) => {
  const tags = Object.assign({
    errorType: errorTags.type,
    errorSource: errorTags.source
  }, errorTags.operation && {
    operation: errorTags.operation
  });
  // If the error is not an Error instance, we create a generic Error object
  const error = exceptionError instanceof Error ? exceptionError : new Error('Unknown error');
  // If the error is not an Error instance, we add it to the extra object
  const extra = exceptionError instanceof Error ? {} : {
    errorInfo: exceptionError
  };
  Raven.captureException(error, {
    extra,
    tags
  });
};